/**
 * Pause interval polling while the document is hidden (background tab / mobile app switch).
 * Browsers often abort in-flight XHR with ERR_NETWORK when visibility is hidden.
 */
export function attachDocumentVisibilityPolling({ pause, resume }) {
    if (typeof document === 'undefined') {
        return () => {}
    }

    const onVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            pause()
            return
        }
        resume()
    }

    document.addEventListener('visibilitychange', onVisibilityChange)
    if (document.visibilityState === 'hidden') {
        pause()
    }

    return () => document.removeEventListener('visibilitychange', onVisibilityChange)
}
